<template>
  <div class="header-container bgShadow">
    <!--<div class="logoWarp">-->
      <!--<img src="../../../static/img/MA LOGO.png"/>-->
    <!--</div>-->
    <div class="container-warp">
      <div class="shop-select">
        <el-select v-model="shopCode" class="circular-select" @change="changeShopcode">
          <el-option
            v-for="item in shopList"
            :key="item.sellerId"
            :label="item.shopName"
            :value="item.sellerId">
          </el-option>
        </el-select>
      </div>
      <div class="menu-list" v-if="menuList && menuList.length != 0">
        <el-menu
          class="hearder-menu"
          :default-active="activeMenu"
          :background-color="variables.menuBg"
          :text-color="variables.menuText"
          :active-text-color="variables.menuActiveText"
          mode="horizontal"
          @select="selectMenu"
          router>

          <el-menu-item v-if="!item.parent && menu" v-for="(item,index) in menuList" :key="index" :index="item.path"
                        :disabled="item.children.length==0"><span v-if="!item.hiddens">{{item.meta.title}}</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div class="user-select">
          <!-- <span class="fon12">平台选择</span>
          <el-select v-model="formMenu.data" placeholder="请选择" class="w90" @change="cutPlat">
              <el-option
                      v-for="item in menusList"
                      :key="item.platName"
                      :label="item.platName"
                      :value="item.plat">
              </el-option>
          </el-select> --> 
          <span class="accredit">{{showEndDate}}</span>
          <span v-if="showReOrder" style="font-size: 12px">立即<span class="fon12" @click="jumpOut">续订</span></span>
          
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">{{username}}<i class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.replace({path:'/system'})" v-if="this.adminFlag===1">系统设置</el-dropdown-item>
            <el-dropdown-item @click.native="exitSys()">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  import headerNavJs from "./headerNav.js"

  export default headerNavJs
</script>

<style lang="scss" scoped>
  @import "headerNav";
</style>



// WEBPACK FOOTER //
// src/layout/headerNav/headerNav.vue